"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _MultipleChoiceFilter = _interopRequireDefault(require("../MultipleChoiceFilter"));
var _Button = _interopRequireDefault(require("../Button"));
var _FilterGroup = _interopRequireDefault(require("../FilterGroup/FilterGroup"));
var _SuggestedFilterLabel = _interopRequireDefault(require("./SuggestedFilterLabel"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.994 10.893l9.9-9.9m-9.872.029l9.9 9.9",
    fill: "none",
    stroke: "#919499",
    strokeWidth: "1.04"
  }));
};
CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
};
var SuggestedFilters = function SuggestedFilters(_ref) {
  var label = _ref.label,
    buttonText = _ref.buttonText,
    filters = _ref.filters,
    onApply = _ref.onApply,
    onClose = _ref.onClose,
    isMobile = _ref.isMobile,
    className = _ref.className;
  var _useState = (0, _react.useState)(filters.reduce(function (result, _ref2) {
      var id = _ref2.id,
        selected = _ref2.selected;
      return _objectSpread(_objectSpread({}, result), (0, _defineProperty2["default"])({}, id, selected));
    }, {})),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedItems = _useState2[0],
    setSelected = _useState2[1];
  var handleChange = function handleChange(_ref3) {
    var id = _ref3.id;
    return setSelected(_objectSpread(_objectSpread({}, selectedItems), (0, _defineProperty2["default"])({}, id, !selectedItems[id])));
  };
  var items = filters.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      selected: selectedItems[item.id]
    });
  });
  var handleApply = function handleApply() {
    return onApply(items.filter(function (item) {
      return item.selected;
    }).map(function (item) {
      return item.id;
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(StyledSuggestedFilters, {
    className: className,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(_FilterGroup["default"], {
    label: label,
    isMobile: isMobile
  }, onClose && /*#__PURE__*/_react["default"].createElement(StyledCloseIcon, {
    onClick: onClose
  }), /*#__PURE__*/_react["default"].createElement(_MultipleChoiceFilter["default"], {
    items: items,
    LabelComponent: _SuggestedFilterLabel["default"],
    onChange: handleChange,
    isMobile: isMobile
  }), /*#__PURE__*/_react["default"].createElement(StyledButton, {
    onClick: handleApply,
    disabled: !items.some(function (item) {
      return item.selected;
    })
  }, buttonText)));
};
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "SuggestedFilters__StyledButton",
  componentId: "sc-drmzkz-0"
})(["font-size:14px;width:100%;margin-top:10px;"]);
var StyledCloseIcon = (0, _styledComponents["default"])(CloseIcon).withConfig({
  displayName: "SuggestedFilters__StyledCloseIcon",
  componentId: "sc-drmzkz-1"
})(["position:absolute;top:8px;right:8px;cursor:pointer;width:15px;height:15px;path{stroke:", ";}&:hover{path{stroke:", ";}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.frenchGray;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.black;
});
var StyledSuggestedFilters = _styledComponents["default"].div.withConfig({
  displayName: "SuggestedFilters__StyledSuggestedFilters",
  componentId: "sc-drmzkz-2"
})(["position:relative;padding:15px;margin-top:10px;", " ", ""], function (_ref6) {
  var theme = _ref6.theme;
  return (0, _styledComponents.css)(["background:", ";border-radius:", ";"], theme.colors.white, theme.shape.borderRadius);
}, function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile && (0, _styledComponents.css)(["padding-left:0;padding-right:0;", "{width:20px;height:20px;top:13px;right:13px;}", "{font-size:15px;width:calc(100% - 20px);margin-right:10px;margin-left:10px;}"], StyledCloseIcon, StyledButton);
});
SuggestedFilters.propTypes = {
  className: _propTypes["default"].string,
  label: _propTypes["default"].string.isRequired,
  buttonText: _propTypes["default"].string,
  onApply: _propTypes["default"].func.isRequired,
  onClose: _propTypes["default"].func,
  filters: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    selected: _propTypes["default"].bool.isRequired,
    title: _propTypes["default"].node.isRequired,
    description: _propTypes["default"].node.isRequired
  })).isRequired,
  isMobile: _propTypes["default"].bool
};
SuggestedFilters.defaultProps = {
  className: '',
  buttonText: _localization.i18n.t('filters.suggested.apply'),
  onClose: null,
  isMobile: false
};
var _default = exports["default"] = SuggestedFilters;